import React, { useState } from "react";
import Navbar from "../Components/Navbar";
import "./Header.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./GeneralDermatology.css";
import "../CSS/theme.css";
import Acne from "./General Dermatology Pages/BenignSkinLesions";
import Actinic from "./General Dermatology Pages/Moles";
import Allergy from "./General Dermatology Pages/Haemangiomas";
import SkinTags from "./General Dermatology Pages/SkinTags";
import SeborrheicWarts from "./General Dermatology Pages/SeborrheicWarts";
import Cysts from "./General Dermatology Pages/Cysts";
import Lipomas from "./General Dermatology Pages/Lipomas";
import KeloidScars from "./General Dermatology Pages/KeloidScars";
import FooterNew from "../Components/FooterNew";
import QuickLinks from "./QuickLinks";
import DermatologyConditions from "./DermatologyConditions";

const GeneralDermatology = () => {
  const CWD = "";
  const heroBgImage = `${CWD}/assets/img/gallery/dr-banner-6.jpg`;

  const [activeTab, setActiveTab] = useState("Overview");

  const handleTabClick = (tab) => {
    setActiveTab(activeTab === tab ? null : tab);
  };

  return (
    <div style={{ maxWidth: "100%", overflow: "hidden" }}>
      <Navbar />
      <div className="Main-Header-Container">
        <section
          className="py-xxl-10 pb-0"
          id="home"
          style={{ background: "rgb(0 0 0 / 60%)", height: "610px" }}
        >
          <div
            className="bg-holder"
            style={{
              backgroundImage: `url(${heroBgImage})`,
              backgroundPosition: "center",
              backgroundSize: "cover",

              //   height: "100vh", // Add a height to ensure background is visible
            }}
          />

          <div className="container">
            <div className="row min-vh-xl-100 min-vh-xxl-25">
              <div className=" paddin-header   text-center ">
                <h2 className="">
                  <span
                    className=" general-tittle-mbl"
                    style={{
                      fontSize: "48px",
                      fontFamily: "Raleway, sanf-serif",
                      color: "#fff",
                      paddingBottom: " 10px",
                    }}
                  >
                    General Dermatology
                  </span>
                </h2>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div
        className=" "
        style={{
          marginTop: "80px",
          padding: "5px 30px 0px",
        }}
      >
        <DermatologyConditions />
      </div>

      {/* <div className="Acne-Container mt-7">
        <Acne />
      </div>
      <div className="Actinic-Container">
        <Actinic />
      </div>
      <div className="Allergy-Container">
        <Allergy />
      </div>
      <div className="SkinTags-Container">
        <SkinTags />
      </div>
      <div className="SeborrheicWarts-Container">
        <SeborrheicWarts />
      </div>
      <div className="Cysts-Container">
        <Cysts />
      </div>
      <div className="Lipomas-Container">
        <Lipomas />
      </div>
      <div className="KeloidScars-Container">
        <KeloidScars />
      </div> */}
      <div className="footer-import footer-import-contact mt-5">
        <QuickLinks />
        <FooterNew />
      </div>
    </div>
  );
};

export default GeneralDermatology;
